import { useState, useEffect } from "react";
import './commissions.css'


const srcTmplt = (filename) => `https://storage.ko-fi.com/cdn/useruploads/post/${filename}`
const altTmplt = (subject, index) => `${subject} image ${index}`
const commissionLinkUrlTmplt = (Alias) => `http://ko-fi.com/c/${Alias}`

const ThumbnailSlide = ({ src, alt }) => {
    return (
        <a
            className="thumbnail-slide">
            <img
                loading="lazy"
                alt={alt}
                src={src}
                className="thumbnail-slide"
            />
        </a>
    )
}

// const ThumbnailRightBtn = () =>  <div className="slide-btn"> <ChevronRightIcon /> </div>

const ThumbnailSlider = ({ thumbnails }) => {
    return (<div className="kofi-thumbnail-slider">
        {thumbnails.map((x, i) => <ThumbnailSlide key={i} src={x.src} alt={x.alt} />)}
    </div>
    )
}

const mapThumbnailsToImgAttributes = (Name, Thumbnails) => {
    return Thumbnails.map((filename, i) => ({ src: srcTmplt(filename), alt: altTmplt(Name, i) }))
}

export function KofiCommissionCard({ item }) {

    const { Alias, Name, Price, ThumbnailUrls, Description, AddOnsAvailable } = item;

    const [kofiLinkUrl, setKofiLinkUrl] = useState(null)
    const [thumbnailsData, setThumbnailsData] = useState([])

    useEffect(() => {
        if (Name && ThumbnailUrls) setThumbnailsData(mapThumbnailsToImgAttributes(Name, ThumbnailUrls))
    }, [Name, ThumbnailUrls])

    useEffect(() => {
        if (Alias) setKofiLinkUrl(commissionLinkUrlTmplt(Alias))
    }, [Alias])

    return (
        <div className="kofi-commissions-root kofi-commission-card">
            <header className="kofi-commission-header">
                <div className="commission-name-column">
                    <h4 className="commission-name">{Name}</h4>
                </div>
                <div className="commission-price-column" >
                    <span className="commission-price">{`$${Price}+`}</span>
                </div>
            </header>
            <div>
                <p>{Description}</p>
            </div>
            <ThumbnailSlider thumbnails={thumbnailsData} />
            <div>
                {AddOnsAvailable && <p className="add-ons-available">Add-ons available</p>}
                <a className="kofi-action-button request-commission-btn"
                    href={kofiLinkUrl}>Request on Ko-fi</a>
            </div>
        </div>
    )
}

export function KofiCommissionsList({ items }) {
    return (
        <div className="kofi-commissions-root commissions-list-wrapper kofi-background">
            {items.map((item, index) => <KofiCommissionCard key={index} item={item} />)}
        </div>
    )
}
